import { Search, X } from "lucide-react"
import { Input } from "../../ui/input"
import { Button } from "../../ui/button"

interface SearchBarProps {
    searchTerm: string
    onSearchChange: (value: string) => void
    onClearSearch: () => void
    placeholder?: string
}

export function SearchBar({ 
    searchTerm, 
    onSearchChange, 
    onClearSearch, 
    placeholder = "Search projects by name, client, or city..." 
}: SearchBarProps) {
    return (
        <div className="relative flex items-center w-full max-w-2xl mx-auto mb-6">
            <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                    type="text"
                    placeholder={placeholder}
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="pl-10 pr-10 h-11 text-base"
                />
                {searchTerm && (
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={onClearSearch}
                        className="absolute right-1 top-1/2 transform -translate-y-1/2 h-8 w-8 p-0 hover:bg-muted"
                    >
                        <X className="h-4 w-4" />
                    </Button>
                )}
            </div>
        </div>
    )
}
